import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import { listIds, mergeIds, setStatus, getParams, compactAndFilter } from '@/utils'

const module = 'campaigns'
let doc = {
  list: {
    name: 'Campagnes',
    headers: [
      { label: 'Statut', value: 'status.name' },
      { label: 'Nom', value: 'visual.name' },
      { label: 'Client', value: 'visual.client.name' },
      { label: 'Début', value: 'dateUp', orig: 'date_up', card: false },
      { label: 'Fin', value: 'dateDown', orig: 'date_down', card: false },
      { label: 'Statut', value: 'status.name', card: false },
      { label: 'Dates', value: 'dates', sortable: false, inTable: false },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['campaigns.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['campaigns.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md6' },
      { label: 'Nom', type: 'multilist', from: 'name', name: 'visual_id', source: 'visuals' },
      { label: 'Client', type: 'multilist', from: 'name', name: 'client_id', source: 'clients' },
      {
        label: 'Statut',
        type: 'multilist',
        from: 'name',
        name: 'status_id',
        source: 'statuses',
        context: {params: {'status_type_id': 4}},
      },
    ],
  },

  form: {
    name: 'Campagne',
    hasPhoto: true,
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['campaigns.update'], dispatch: `${module}/update` },
      { label: 'Rapport', icon: 'assignment', dispatch: `${module}/report` },
      { label: 'Fermer', icon: 'power_off', filter: {status_id: 10}, dispatch: `${module}/closeCampaign` },
      {
        label: 'Archiver',
        icon: 'delete',
        filter: {status_id: 11},
        scope: ['campaigns.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    fields: [
      { label: 'Client', type: 'list', from: 'name', name: 'client_id', source: 'clients' },
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Début', type: 'date', name: 'date_up' },
      { label: 'Fin', type: 'date', name: 'date_down' },
    ],
    relations: [
      {
        name: 'Affichés',
        source: 'displays',
        headers: [
          { label: 'Code', value: 'face.full_code' },
          { label: 'Adresse', value: 'face.board.adress' },
          { label: 'District', value: 'face.board.district.name' },
          { label: 'Ville', value: 'face.board.district.city.name' },
          { label: 'Région', value: 'face.board.district.city.region.name' },
          { label: 'Affiché le', value: 'dateUp', orig: 'date_up' },
          { label: 'Par', value: 'user.username' },
        ],
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `displays/goTo` },
        ],
        selectActions: [
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `displays/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `displays/export`,
            context: {format: 'xls'},
            menu: true,
          },
          {
            label: 'Rapport',
            icon: 'assignment',
            isFlat: true,
            dispatch: `campaigns/selectionReport`,
            menu: true,
          },
        ],
        dispatch: 'getUp',
      },
      {
        name: 'En Attente',
        source: 'pendingdisplays',
        headers: [
          { label: 'Code', value: 'face.full_code' },
          { label: 'Adresse', value: 'face.board.adress' },
          { label: 'District', value: 'face.board.district.name' },
          { label: 'Ville', value: 'face.board.district.city.name' },
          { label: 'Région', value: 'face.board.district.city.region.name' },
        ],
        dispatch: 'getPending',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `displays/goTo` },
        ],
        selectActions: [
          { label: 'Supprimer', icon: 'delete', scope: ['displays.delete'], dispatch: `${module}/cancelDisplay` },
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `pendingdisplays/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `pendingdisplays/export`,
            context: {format: 'xls'},
            menu: true,
          },
        ],
      },
      {
        name: 'Désaffichés',
        source: 'offdisplays',
        headers: [
          { label: 'Code', value: 'face.full_code' },
          { label: 'Adresse', value: 'face.board.adress' },
          { label: 'District', value: 'face.board.district.name' },
          { label: 'Ville', value: 'face.board.district.city.name' },
          { label: 'Région', value: 'face.board.district.city.region.name' },
          { label: 'Affiché le', value: 'dateUp', orig: 'date_up' },
          { label: 'Par', value: 'user.username' },
          { label: 'Désaffiché le', value: 'dateDown', orig: 'date_down' },
        ],
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `displays/goTo` },
        ],
        selectActions: [
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `offdisplays/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `offdisplays/export`,
            context: {format: 'xls'},
            menu: true,
          },
        ],
        dispatch: 'getDown',
      },
      {
        name: 'Disponibles',
        source: 'bookings',
        headers: [
          { label: 'En affichage', value: 'inUse' },
          { label: 'Client', value: 'basket.client.name' },
          { label: 'Type', value: 'face.board.board_type.name' },
          { label: 'Code', value: 'face.full_code' },
          { label: 'Adresse', value: 'face.board.adress' },
          { label: 'District', value: 'face.board.district.name' },
          { label: 'Ville', value: 'face.board.district.city.name' },
          { label: 'Région', value: 'face.board.district.city.region.name' },
          { label: 'Début', value: 'dateStart', orig: 'basket.date_start' },
          { label: 'Fin', value: 'dateEnd', orig: 'basket.date_end' },
        ],
        dispatch: 'getAvailable',
        selectActions: [
          {
            label: 'Inclure',
            icon: 'pan_tool',
            scope: ['displays.create'],
            dispatch: `${module}/requestDisplay`,
          },
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `bookings/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `bookings/export`,
            context: {format: 'xls'},
            menu: true,
          },
        ],
      },
    ],
  },

  postprocess: item => {
    let dateUp = moment(item.date_up).format('DD/MM/YYYY')
    let dateDown = item.date_down !== null ? moment(item.date_down).format('DD/MM/YYYY') : ''
    let imgPath = item.visual ? item.visual.img_path : undefined
    let name = item.visual ? item.visual.name : undefined
    // eslint-disable-next-line
    let client_id = item.visual ? item.visual.client_id : undefined
    return {
      ...item,
      img_path: imgPath,
      dateUp,
      dateDown,
      name,
      client_id,
      dates: `${dateUp} - ${dateDown}`,
    }
  },

  params: {
    fetchAll: {include: 'visual.client,status'},
    fetchOne: {include: 'visual.client,status'},
  },
}
const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    selectionReport: ({commit}, payload) => {
      const { context, data } = payload
      let displayIds = mergeIds(data)
      let params = {campaign_id: context.id, display_ids: displayIds}
      commit('EXPORT_REQUEST', payload)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('campaigns', `reports/displays`, {}, params, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
        })
    },
    report: ({ commit }, payload) => {
      const { context } = payload
      commit('EXPORT_REQUEST', payload)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('campaigns', `reports/campaign/${context.id}`, {}, {}, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
        })
    },
    closeCampaign: ({ commit, dispatch }, payload) => {
      const { context } = payload
      apiClient.dropCache('bookings')
      apiClient.dropCache('displays')
      apiClient.dropCache('pendingdisplays')
      apiClient.dropCache('offdisplays')
      setStatus(apiClient, module, commit, dispatch, payload, 'down').then(resp => {
        dispatch('fetchOne', {accessors: {}, context, data: context.id})
        dispatch('getAvailable', {accessors: {}, context, data: context.id})
        dispatch('getUp', {accessors: {}, context, data: context.id})
        dispatch('getDown', {accessors: {}, context, data: context.id})
        dispatch('getPending', {accessors: {}, context, data: context.id})
      })
    },
    getAvailable: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('bookings/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        ...baseParams,
        include: 'face.board.district.city.region,face.board.board_type,basket.client',
      }
      apiClient.fetchCustom('bookings', `bookings/campaign/${context.id}`, params)
        .then(data => {
          let updatedData = data.map(item => ({
            ...item,
            img_path: item.face ? item.face.img_path : null,
          }))
          commit('bookings/LIST_SUCCESS', updatedData, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('bookings/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getUp: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('displays/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        ...baseParams,
        include: 'face.board.district.city.region,face.board.board_type,user',
      }
      apiClient.fetchCustom('displays', `displays/campaign/${context.id}/up`, params)
        .then(data => {
          commit('displays/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('displays/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getDown: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('offdisplays/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        ...baseParams,
        include: 'face.board.district.city.region,face.board.board_type,user',
      }
      apiClient.fetchCustom('displays', `displays/campaign/${context.id}/down`, params)
        .then(data => {
          commit('offdisplays/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('offdisplays/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getPending: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('pendingdisplays/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        ...baseParams,
        include: 'face.board.district.city.region,face.board.board_type',
      }
      apiClient.fetchCustom('displays', `displays/campaign/${context.id}/pending`, params)
        .then(data => {
          commit('pendingdisplays/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('pendingdisplays/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    requestDisplay: ({ commit, dispatch }, payload) => {
      commit('bookings/SET_LOADING', true, { root: true })
      const {context, data} = payload
      let nData = {ids: listIds(data)}
      commit('UPDATE_REQUEST', nData)
      apiClient.dropCache('bookings')
      apiClient.dropCache('displays')
      apiClient.dropCache('pendingdisplays')
      apiClient.dropCache('offdisplays')
      apiClient.postCustom(module, `campaigns/${context.id}/request`, nData, getParams(context))
        .then(response => {
          commit('UPDATE_SUCCESS', response)
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          dispatch('getAvailable', {accessors: {}, context, data: context.id})
          dispatch('getUp', {accessors: {}, context, data: context.id})
          dispatch('getDown', {accessors: {}, context, data: context.id})
          dispatch('getPending', {accessors: {}, context, data: context.id})
          commit('bookings/SET_LOADING', false, { root: true })
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          console.log(error)
          commit('bookings/SET_LOADING', false, { root: true })
        })
    },
    cancelDisplay: ({ commit, dispatch }, payload) => {
      commit('pendingdisplays/SET_LOADING', true, { root: true })
      const {context, data} = payload
      let nData = {ids: listIds(data)}
      console.log(nData)
      apiClient.dropCache('displays')
      apiClient.dropCache('pendingdisplays')
      apiClient.dropCache('offdisplays')
      commit('UPDATE_REQUEST', nData)
      apiClient.postCustom(module, `campaigns/${context.id}/cancel`, nData, getParams(context))
        .then(response => {
          commit('UPDATE_SUCCESS', response)
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          dispatch('getAvailable', {accessors: {}, context, data: context.id})
          dispatch('getUp', {accessors: {}, context, data: context.id})
          dispatch('getDown', {accessors: {}, context, data: context.id})
          dispatch('getPending', {accessors: {}, context, data: context.id})
          commit('pendingdisplays/SET_LOADING', false, { root: true })
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          console.log(error)
          commit('pendingdisplays/SET_LOADING', false, { root: true })
        })
    },
  },
}
export default merge(base, custom)
